import classNames from "classnames/bind";
import styles from "./index.module.scss";

const cn = classNames.bind(styles);

function View({self, ranking, record, medalImg, name}) {
  return (
    <div className={cn("ranking_item", self && "self")}>
      <div className={cn("inner")}>
        <span className={cn("rank")}>
          {ranking > 3 || ranking === "-" ? (
            <p>{ranking?.toLocaleString()}</p>
          ) : (
            <img alt="medal" src={medalImg} />
          )}
        </span>

        <span className={cn("user_name")}>{name}</span>
        <span className={cn("record")}>{record}</span>
      </div>
    </div>
  );
}

export default View;
